export const textStyle = { 
    textAlign: 'center',
    color: 'white',
    fontWeight:'700'
}

export const playerStyle = { 
    height: '500px',
    width: '500px'
}